import api from 'src/services/api';
import { UserEndpoints } from './constants';
import { GetUserDataByUcodeParams, GetUserPostsByUcodeParams } from './types';

export const getUserDataByUcode = async ({ ucode, avatarDimensions }: GetUserDataByUcodeParams) => {
  const url = UserEndpoints.getUserDataByUcode(ucode);

  const res = await api.get(url, {
    params: {
      avatarDimensions
    }
  });

  return res.data;
};

export const getUserPostsByUcode = async ({
  ucode,
  rows,
  pageToken
}: GetUserPostsByUcodeParams) => {
  const url = UserEndpoints.getUserPostsByUcode(ucode);

  const res = await api.get(url, {
    params: {
      rows,
      pageToken
    }
  });

  return res.data;
};
